import React from 'react';
import useDelayedFlag from 'react/hooks/useDelayedFlag';
import { CHAT_LOADING_DELAY, CHAT_LOADING_SLOW } from 'react/chat/inner/display_pieces/loading/chatLoadingTimes';
import { __ } from 'i18n/index';

const ROW_WIDTHS = [62, 38, 80, 54, 30, 70, 46];

// The message-shaped rows; the netplay page's chat skeleton shows them too.
export function ChatMessageRowsSkeleton() {
	return (
		<div className='chat-skeleton__rows' aria-hidden='true'>
			{ROW_WIDTHS.map((width, index) => (
				<div className='chat-skeleton__row' key={index}>
					<div className='chat-skeleton__bar chat-skeleton__bar--name' />
					<div className='chat-skeleton__bar' style={{ width: `${width}%` }} />
				</div>
			))}
		</div>
	);
}

// Stands in for the message list until a conversation's first messages arrive.
export default function ChatFirstLoadPlaceholder({ isLoading, failed, onRetry }) {
	const showRows = useDelayedFlag(isLoading, CHAT_LOADING_DELAY);
	const isSlow = useDelayedFlag(isLoading, CHAT_LOADING_SLOW);

	function retry() {
		onRetry().catch((error) => {
			console.error(error);
		});
	}

	const retryButton = (
		<button type='button' className='chat-skeleton__retry' onClick={retry}>{__('Retry')}</button>
	);

	if(failed) {
		return (
			<div className='chat-skeleton__notice chat-skeleton__notice--failed'>
				<span>{__("Couldn't load messages.")}</span> {retryButton}
			</div>
		);
	}
	if(!showRows) {
		return null;
	}
	return (
		<div className='chat-skeleton'>
			<ChatMessageRowsSkeleton />
			{isSlow &&
			<div className='chat-skeleton__notice'>
				<span>{__('Still loading…')}</span> {retryButton}
			</div>
			}
		</div>
	);
}
